import { Contract } from 'entities/Contract';
import { DocumentType, InvoiceItem } from 'entities/Invoice';
import { Payment } from 'entities/Payment';
import { User } from 'entities/User';

export interface Deposit {
  depositId: string;
  user: User;
  invoiceItem: InvoiceItem;
  description?: string;
  isRefunded: boolean;
  contract: Contract;
  initialDepositAmount: number;
  cancelledDepositAmount: number;
  refundedDepositAmount: number;
  chargedDepositAmount: number;
  depositAmount: number;
  documentNumber: string;
  documentType: DocumentType;
  charges: DepositCharge[];
  depositHistory: DepositHistory[];
  createdAt: string;
}

export interface DepositHistory {
  depositHistoryId: string;
  depositAmount: number;
  cancelledDepositAmount: number;
  refundedDepositAmount: number;
  chargedDepositAmount: number;
  depositAmountDiff: number;
  cancelledDepositAmountDiff: number;
  refundedDepositAmountDiff: number;
  chargedDepositAmountDiff: number;
  isRefunded: boolean;
  createdAt: string;
  updatedAt: string;
  description: string;
}

export interface DepositCharge {
  depositChargeId: string;
  description?: string;
  deposit: Deposit;
  amount: number;
  documentType: DocumentType;
  documentNumber: string;
  createdAt: string;
}

export interface DepositRefundNote {
  depositRefundNoteId: string;
  user: User;
  deposit: Deposit;
  payment: Payment;
  description?: string;
  issuedBy?: string;
  refundAmount: number;
  documentNumber: string;
  documentType: DocumentType;
}

export interface ChargeDepositParams {
  depositId: string;
  amount: number;
  description?: Nullable<string>;
}

export enum DepositPaymentStatus {
  NOT_PAID = 'Not paid',
  PAID = 'Paid',
  PARTIAL_PAYMENT = 'Partial payment',
  PARTIAL_REFUND = 'Partial refund',
  CANCELLED = 'Cancelled',
  REFUNDED = 'Refunded',
  NOT_REFUNDED = 'Not refunded',
}
